// AUTO-GENERATED by tools/generate-parallel.mjs --world 10. Do not edit by hand.
// Regenerate with: node tools/generate-parallel.mjs --world 10
// W10 (Obsidian) — final world. Pure d=9 pack, mixed geometry.
import type { LevelDef } from '@tessera/engine';

export const WORLD_10_GENERATED: LevelDef[] = [
  // d*=9  branching=15.78  D=0.073  tiles=15
  {
    id: 'w10-l01',
    world: 10,
    index: 1,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: 2, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 4, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 0 },
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: 1, r: -3 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 2 },
    { coord: { q: 3, r: -1 }, color: 2 },
    { coord: { q: -3, r: 2 }, color: 3 },
    { coord: { q: -3, r: 1 }, color: 3 },
    { coord: { q: 0, r: -3 }, color: 4 },
    { coord: { q: 3, r: 0 }, color: 4 },
    ],
  },
  // d*=9  branching=19.76  D=0.064  tiles=13
  {
    id: 'w10-l02',
    world: 10,
    index: 2,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: 1, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 2 },
    { coord: { q: -3, r: 2 }, color: 2 },
    { coord: { q: 3, r: -3 }, color: 3 },
    { coord: { q: 3, r: 0 }, color: 3 },
    ],
  },
  // d*=9  branching=20.16  D=0.065  tiles=15
  {
    id: 'w10-l03',
    world: 10,
    index: 3,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: -2, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 0 }, color: 4, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: 2, r: -3 }, color: 0 },
    { coord: { q: -1, r: 3 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: -2, r: -1 }, color: 2 },
    { coord: { q: -3, r: 2 }, color: 2 },
    { coord: { q: 3, r: -2 }, color: 3 },
    { coord: { q: 3, r: -3 }, color: 3 },
    { coord: { q: 1, r: 2 }, color: 4 },
    { coord: { q: -1, r: -2 }, color: 4 },
    ],
  },
  // d*=9  branching=21.37  D=0.069  tiles=15
  {
    id: 'w10-l04',
    world: 10,
    index: 4,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: -3, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 0 }, color: 4, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: 3, r: -1 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: 1, r: -3 }, color: 2 },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: -1, r: 3 }, color: 3 },
    { coord: { q: 2, r: 1 }, color: 3 },
    { coord: { q: 1, r: 2 }, color: 4 },
    { coord: { q: -1, r: -2 }, color: 4 },
    ],
  },
  // d*=9  branching=21.63  D=0.047  tiles=15
  {
    id: 'w10-l05',
    world: 10,
    index: 5,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: 3, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 4, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 3, r: -1 }, color: 1 },
    { coord: { q: 1, r: 2 }, color: 2 },
    { coord: { q: 0, r: 3 }, color: 2 },
    { coord: { q: 0, r: -3 }, color: 3 },
    { coord: { q: -3, r: 0 }, color: 3 },
    { coord: { q: 2, r: -3 }, color: 4 },
    { coord: { q: 1, r: -3 }, color: 4 },
    ],
  },
  // d*=9  branching=23.21  D=0.150  tiles=15
  {
    id: 'w10-l06',
    world: 10,
    index: 6,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: 2, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -2 }, color: 4, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 1, r: 2 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 2 },
    { coord: { q: 1, r: -3 }, color: 2 },
    { coord: { q: 3, r: -1 }, color: 3 },
    { coord: { q: 3, r: -3 }, color: 3 },
    { coord: { q: -3, r: 2 }, color: 4 },
    { coord: { q: -2, r: 3 }, color: 4 },
    ],
  },
  // d*=9  branching=24.18  D=0.056  tiles=15
  {
    id: 'w10-l07',
    world: 10,
    index: 7,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: -1, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 0 }, color: 4, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 1 },
    { coord: { q: 3, r: -1 }, color: 2 },
    { coord: { q: 2, r: 1 }, color: 2 },
    { coord: { q: -2, r: -1 }, color: 3 },
    { coord: { q: -1, r: -2 }, color: 3 },
    { coord: { q: -3, r: 3 }, color: 4 },
    { coord: { q: 0, r: -3 }, color: 4 },
    ],
  },
  // d*=9  branching=24.81  D=0.058  tiles=15
  {
    id: 'w10-l08',
    world: 10,
    index: 8,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: 3, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 3 }, color: 4, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: -1, r: -2 }, color: 2 },
    { coord: { q: 0, r: -3 }, color: 2 },
    { coord: { q: 2, r: 1 }, color: 3 },
    { coord: { q: -3, r: 3 }, color: 3 },
    { coord: { q: 1, r: -3 }, color: 4 },
    { coord: { q: 2, r: -3 }, color: 4 },
    ],
  },
  // d*=9  branching=25.12  D=0.082  tiles=15
  {
    id: 'w10-l09',
    world: 10,
    index: 9,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: 3, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 0 }, color: 4, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 3, r: -1 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: 1, r: -3 }, color: 2 },
    { coord: { q: -1, r: 3 }, color: 3 },
    { coord: { q: -2, r: 3 }, color: 3 },
    { coord: { q: -3, r: 3 }, color: 4 },
    { coord: { q: 1, r: 2 }, color: 4 },
    ],
  },
  // d*=9  branching=28.50  D=0.094  tiles=15
  {
    id: 'w10-l10',
    world: 10,
    index: 10,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: 3, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 0 }, color: 4, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 2 },
    { coord: { q: 1, r: 2 }, color: 2 },
    { coord: { q: -2, r: -1 }, color: 3 },
    { coord: { q: -1, r: -2 }, color: 3 },
    { coord: { q: 2, r: -3 }, color: 4 },
    { coord: { q: 2, r: 1 }, color: 4 },
    ],
  },
];
